export default __webpack_public_path__ + "static/premio-fase2-999d90af4ce9198d1030668c789fac96.png";